/**
 * Click-to-expand JSON block. Collapsed shows a one-liner preview; expanded
 * shows pretty-printed JSON inside a `.args-json` block.
 */
import { useState } from "react";
import { clsx } from "clsx";

interface Props {
  value: unknown;
  preview?: string;
  /** When true, the block starts expanded. */
  defaultExpanded?: boolean;
}

export function JsonExpand({ value, preview, defaultExpanded }: Props) {
  const [open, setOpen] = useState(!!defaultExpanded);

  const previewText =
    preview ??
    (() => {
      try {
        const s = JSON.stringify(value);
        return s.length > 80 ? `${s.slice(0, 80)}…` : s;
      } catch {
        return "(unprintable)";
      }
    })();

  return (
    <div>
      <button
        type="button"
        className={clsx("btn btn-ghost btn-sm")}
        onClick={() => setOpen((v) => !v)}
        style={{ padding: "4px 8px", textTransform: "none", letterSpacing: 0 }}
        aria-expanded={open}
      >
        <span style={{ fontFamily: "ui-monospace, monospace", fontSize: "0.8rem" }}>
          {open ? "▾" : "▸"} {open ? "Hide JSON" : previewText}
        </span>
      </button>
      {open ? (
        <pre className="args-json mt-2">{prettyPrint(value)}</pre>
      ) : null}
    </div>
  );
}

function prettyPrint(value: unknown): string {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
